const defaultAccessoriesFlatFacetConfig = ["color", "other"];
const defaultSunglassesFlatFacetConfig = [
  "frameColor",
  "frameLensColor"
];
const defaultFramesFlatFacetConfig = ["frameColor", "frameLensColor"];
const defaultReadyReadersFlatFacetConfig = ["power"];
const defaultSolutionsFlatFacetConfig = ["packageOption"];
export {
  defaultFramesFlatFacetConfig as a,
  defaultReadyReadersFlatFacetConfig as b,
  defaultSolutionsFlatFacetConfig as c,
  defaultAccessoriesFlatFacetConfig as d,
  defaultSunglassesFlatFacetConfig as e
};
//# sourceMappingURL=default-flat-facet-configs.js.map
